import React from 'react';
import { useTranslation } from "react-i18next";

function OfferOfficialSite(props) {
	const { t } = useTranslation();
	return (
		<a className="detail-body__link" href={props.official_site_url} title="曲目解説・プロフィールはこちらから" target="_blank" rel="noreferrer">
			{t('offer.officalSite')}
		</a>
	);
}

export default OfferOfficialSite;
